module.exports = __webpack_public_path__ + "static/media/pk.e2cc1a30.svg";